import React from 'react';
import ReactDOM from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import './index.css';
import './styles/a11y-strict.css';
import { GameProvider } from './systems';
import { AuthProvider } from './systems/auth-context';
import { WorkspaceProvider } from './systems/workspace-context';
import { PostHogIdentify } from './systems/posthog-identify';
import { AccessibilityProvider } from './systems/accessibility-context';
import { ErrorBoundary } from './components';
import { captureScormLaunch } from './systems/scorm-bridge';

const posthogToken = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;

// Before any login redirect can drop the query string.
captureScormLaunch();

if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
    defaults: '2026-05-30'

  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {posthogToken ? (
      <PostHogProvider client={posthog}>
        <AppTree withIdentify />
      </PostHogProvider>
    ) : (
      <AppTree />
    )}
  </React.StrictMode>
);

function AppTree({ withIdentify = false }: { withIdentify?: boolean }) {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <WorkspaceProvider>
          {withIdentify ? <PostHogIdentify /> : null}
          <AccessibilityProvider>
            <GameProvider>
              <App />
            </GameProvider>
          </AccessibilityProvider>
        </WorkspaceProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
